module.exports = __webpack_public_path__ + "static/media/mvit-img.7d406699.png";